export default "__VITE_ASSET__qUfHn$7r__"